// @flow
export default function isArray(arr: mixed): boolean {
   return Array.isArray(arr);
}
